/**
 * 로그인 직행 리졸버 훅 (TanStack Query)
 *
 * - GET  /auth/landing           마지막 사용 회사 → 그 회사의 마지막 워크스페이스(선택 화면 없이 직행)
 * - POST /workspaces/{slug}/touch  워크스페이스 진입 기록(마지막 사용 갱신)
 *
 * 격리: landing 은 활성 회사 헤더(X-Company-Id) 유무로 로그인/전환을 서버가 동일 처리함.
 * touch 는 UX 편의값 갱신 — 실패해도 화면 흐름을 막지 않는다(감사 대상 아님).
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";

/** GET /auth/landing 응답 — 둘 중 하나라도 null 이면 자동 착지 불가(WS 생성 유도). */
export interface Landing {
  companyId: string | null;
  workspaceSlug: string | null;
}

/** 로그인 착지 대상 조회. 로그인마다 최신이 필요하므로 캐시하지 않는다(staleTime 0). */
export function useLanding(enabled = true) {
  return useQuery({
    queryKey: ["auth", "landing"] as const,
    queryFn: () => apiFetch<Landing>("/api/auth/landing"),
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: false,
  });
}

/** 워크스페이스 진입 기록(마지막 사용 회사·WS 갱신). touch 는 path slug + 활성 회사 컨텍스트만 사용(WS 헤더 불필요). */
export function useTouchWorkspace() {
  return useMutation({
    mutationFn: (slug: string) =>
      apiFetch<void>(`/api/workspaces/${encodeURIComponent(slug)}/touch`, {
        method: "POST",
      }),
  });
}
